import { ReactComponent as AppSettingsSidebarSvg } from "../../assets/images/svgs/appSettingsSidebar.svg";

const AppSettingsSidebarIcon = ({ className = "", ...props }) => {
  return (
    <AppSettingsSidebarSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default AppSettingsSidebarIcon;
